// Debugging confirmation
console.log('✅ build-manager-master-pages.js Builder Manager loaded successfully!');

// Cache builder functions to avoid redundant imports
const _masterBuilderCache = {};

async function loadMasterPageDependencies(masterPagePath) {
  console.log(`🚀 Loading master page builder for: ${masterPagePath}`);

  // Return cached builder if available
  if (_masterBuilderCache[masterPagePath]) {
    return _masterBuilderCache[masterPagePath];
  }

  let builderFn;
  switch (masterPagePath) {
    case 'master-layout-shop':
      builderFn = (
        await import(
          /* webpackChunkName: "master-page-builder-shop" */
          /* webpackPrefetch: true */
          '../builders-master-page/master-page-builder-shop.js'
        )
      ).buildMasterLayoutShop;
      break;
    case 'master-layout-blog':
      builderFn = (
        await import(
          /* webpackChunkName: "master-page-builder-blog" */
          /* webpackPrefetch: true */
          '../builders-master-page/master-page-builder-blog.js'
        )
      ).buildMasterLayoutBlog;
      break;

    case 'master-layout-light':
      builderFn = (
        await import(
          /* webpackChunkName: "master-page-builder-light" */

          '../builders-master-page/master-page-builder-light.js'
        )
      ).buildMasterLayoutLight;
      break;
    case 'master-layout-dashboard-user':
      builderFn = (
        await import(
          /* webpackChunkName: "master-page-builder-dashboard-user.js" */

          '../builders-master-page/master-page-builder-dashboard-user.js'
        )
      ).buildMasterLayoutDashboardUser;
      break;

    case 'master-layout-dashboard-seller':
      builderFn = (
        await import(
          /* webpackChunkName: "master-page-builder-dashboard-seller.js" */

          '../builders-master-page/master-page-builder-dashboard-seller.js'
        )
      ).buildMasterLayoutDashboardSeller;
      break;
    case 'master-layout-terms-and-conditions':
      builderFn = (
        await import(
          /* webpackChunkName: "master-page-builder-terms-and-conditions.js" */

          '../builders-master-page/master-page-builder-terms-and-conditions.js'
        )
      ).buildMasterLayoutTermsAndConditions;
      break;

    case 'master-layout-blank':
      builderFn = (
        await import(
          /* webpackChunkName: "master-page-builder-blank" */
          /* webpackPrefetch: true */
          '../builders-master-page/master-page-builder-blank.js'
        )
      ).buildMasterLayoutBlank;
      break;

    default:
      // Fallback to shop builder
      builderFn = (
        await import(
          /* webpackChunkName: "master-page-builder-shop" */
          /* webpackPrefetch: true */
          '../builders-master-page/master-page-builder-shop.js'
        )
      ).buildMasterLayoutShop;
  }

  // Cache and return
  _masterBuilderCache[masterPagePath] = builderFn;
  return builderFn;
}

export async function buildMasterPageByMasterLayoutBuildManager(masterPagePath) {
  // return "helooe world 555";

  console.log(`🔄 Master Page Build Manager — layout: ${masterPagePath}`);

  try {
    // 1) Load the appropriate builder function
    const buildMasterLayout = await loadMasterPageDependencies(masterPagePath);

    if (typeof buildMasterLayout !== 'function') {
      console.error(`❌ Invalid builder for: ${masterPagePath}`);
      return 'Error: Invalid master page layout.';
    }

    console.log(`✅ Building master page using: ${masterPagePath}`);
    // 2) Execute and return
    return await buildMasterLayout();
  } catch (error) {
    console.error('❌ Error building master page content:', error);
    return 'Error loading master page content.';
  }
}
